import { create } from "zustand";

const REFRESH_TOKEN_KEY = "dm_refresh_token";

export const useAuthStore = create((set) => ({
  user: null,
  accessToken: null,
  refreshToken: localStorage.getItem(REFRESH_TOKEN_KEY) || null,
  isAuthenticated: false,
  role: null,
  modules: [],

  login: (user, accessToken, refreshToken) => {
    localStorage.setItem(REFRESH_TOKEN_KEY, refreshToken);
    set({
      user,
      accessToken,
      refreshToken,
      isAuthenticated: true,
      role: user.role,
      modules: user.modules || [],
    });
  },

  setUser: (user) =>
    set({
      user,
      role: user?.role,
      modules: user?.modules || [],
      isAuthenticated: !!user,
    }),

  setAccessToken: (accessToken) => set({ accessToken }),

  setRefreshToken: (refreshToken) => {
    localStorage.setItem(REFRESH_TOKEN_KEY, refreshToken);
    set({ refreshToken });
  },

  logout: () => {
    localStorage.removeItem(REFRESH_TOKEN_KEY);
    set({
      user: null,
      accessToken: null,
      refreshToken: null,
      isAuthenticated: false,
      role: null,
      modules: [],
    });
  },
}));

// Keep Zustand's in-memory refreshToken in sync with localStorage changes made
// by other tabs.  Without this, a token rotation in Tab A leaves Tab B holding
// the old (now invalid) token in memory, causing its next refresh to fail.
window.addEventListener("storage", (e) => {
  if (e.key !== REFRESH_TOKEN_KEY) return;
  if (e.newValue) {
    // Another tab stored a new refresh token — update our in-memory state
    useAuthStore.setState({ refreshToken: e.newValue });
  } else {
    // Another tab removed the token (logout) — log this tab out too
    useAuthStore.getState().logout();
  }
});
